// Mirrors is-kool-app/lib/dashboard/whatsapp/whatsapp_theme.dart's
// whatsappAvatarColor / whatsappInitials exactly, so a group's avatar circle
// looks the same color on web as it does on mobile.

const PALETTE = [
  "#7C4DFF",
  "#FF7043",
  "#26A69A",
  "#5C6BC0",
  "#EC407A",
  "#8D6E63",
  "#29B6F6",
  "#9CCC65",
];

export function whatsappAvatarColor(seed) {
  const hash = String(seed || "")
    .split("")
    .reduce((acc, ch) => acc + ch.charCodeAt(0), 0);
  return PALETTE[hash % PALETTE.length];
}

export function whatsappInitials(name) {
  const trimmed = String(name || "").trim();
  if (!trimmed) return "?";
  const parts = trimmed.split(/\s+/);
  if (parts.length === 1) return parts[0].charAt(0).toUpperCase();
  return (parts[0].charAt(0) + parts[parts.length - 1].charAt(0)).toUpperCase();
}
